import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import './AddKategori.css';

const AddKategori = ({ isOpen, toggleSidebar, handleLogout }) => {
  const [title, setTitle] = useState('');
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch('https://freddway-v2.credibug.com/api/kategori');
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
      setError('Gagal memuat kategori');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const method = editMode ? 'PUT' : 'POST';
      const endpoint = editMode
        ? `https://freddway-v2.credibug.com/api/editKategori/${editId}`
        : 'https://freddway-v2.credibug.com/api/addKategori';

      const response = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(editMode ? 'Kategori berhasil diperbarui!' : 'Kategori berhasil ditambahkan!');
        setError('');
        setTitle('');
        setEditMode(false);
        setEditId(null);
        fetchCategories();

        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(data.message || 'Terjadi kesalahan saat memproses kategori');
        setSuccess('');
        
        setTimeout(() => setError(''), 3000);
      }
    } catch (err) {
      setError('Terjadi kesalahan saat memproses kategori');
      setSuccess('');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm('Yakin ingin menghapus kategori ini?');
  
    if (!isConfirmed) {
      return;
    }
  
    try {
      const response = await fetch(`https://freddway-v2.credibug.com/api/deleteKategori/${id}`, {
        method: 'DELETE',
      });
  
      const data = await response.json();
  
      if (response.ok) {
        setSuccess('Kategori berhasil dihapus!');
        fetchCategories(); // Memperbarui daftar kategori
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(data.message || 'Terjadi kesalahan saat menghapus kategori');
        setTimeout(() => setError(''), 3000);
      }
    } catch (err) {
      setError('Terjadi kesalahan saat menghapus kategori');
      setTimeout(() => setError(''), 3000);
    }
  };  

  const handleEdit = (id, currentTitle) => {
    setEditMode(true);
    setEditId(id);
    setTitle(currentTitle);
  };

  return (
    <div className="dashboard">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
      <div className={`main-content ${isOpen ? 'expanded' : ''}`}>
        <div className={`add-kategori-container`}>
          <h2>{editMode ? 'Edit Kategori' : 'Tambah Kategori'}</h2>
          <form onSubmit={handleSubmit}>
            <label>Nama Kategori</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
            <button type="submit">{editMode ? 'Update' : 'Tambah'}</button>
          </form>

          {success && <div className="success-message">{success}</div>}
          {error && <div className="error-message">{error}</div>}

          <h3>Daftar Kategori</h3>
          <div className="kategori-table">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nama Kategori</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category) => (
                  <tr key={category.id}>
                    <td>{category.id}</td>
                    <td>{category.title}</td>
                    <td>
                      <button className="edit-button" onClick={() => handleEdit(category.id, category.title)}>Edit</button>
                      <button className="delete-button" onClick={() => handleDelete(category.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddKategori;
